import type { EntityConfig } from '../types'

export const customerEntity: EntityConfig = {
  id: 'customer',
  displayName: 'Customer',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'under_review', label: 'Under Review' },
      { value: 'restricted', label: 'Restricted' },
      { value: 'terminated', label: 'Terminated' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'under_review', label: 'Under Review', color: 'warning' },
      { value: 'restricted', label: 'Restricted', color: 'error' },
      { value: 'terminated', label: 'Terminated', color: 'error' },
    ],
    mappings: {
      all: ['active', 'under_review', 'restricted', 'terminated'],
      active: ['active'],
      under_review: ['under_review'],
      restricted: ['restricted'],
      terminated: ['terminated'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    location: { type: 'string_array', urlKey: 'location' },
    type: { type: 'string_array', urlKey: 'type' },
    customers: { type: 'string_array', urlKey: 'customers' }
  },
  uiFilterFields: [
    'status',
    'dateRange',
    'amount',
    'customers',
  ]
}
